import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import './ads.css';
import moment from 'moment-timezone';
import ShareButton from "../shareButton/shareButton";
import LikeButton from "../Like/LikeButton";
import { Card, CardMedia, CardContent, MobileStepper, IconButton, Button, Box, Skeleton } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight, CalendarMonthOutlined, AccessAlarmsOutlined } from '@mui/icons-material';
import { generateEventoUrl } from '../../utils/generateEventoUrl';

const CardPublicacion = ({
  publicacion,
  isLoading,
  usuario,
  variant = "normal"
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const history = useHistory();
  const { i18n } = useTranslation("global");
  const fechaPublicacion = new Date(publicacion?.desde);
  const fechaBajaPublicacion = new Date(publicacion?.hasta)
  const hoy = new Date();

  moment.locale(i18n.language === "es" ? "es" : "en-gb");

  const maxSteps = publicacion?.attachs?.length || 0;

  const next = () => {
    const nextIndex = activeIndex === publicacion.attachs?.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    const nextIndex = activeIndex === 0 ? publicacion.attachs?.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const handleIconClick = (e) => {
    e.stopPropagation();
  };

  const recienteApertura = () => {
    const diferenciaDias = Math.floor((hoy - fechaPublicacion) / (1000 * 60 * 60 * 24));
    return diferenciaDias >= 0 && diferenciaDias <= 4;
  };
  const proximoAFinalizar = () => {
    const diferenciaDias = Math.floor((fechaBajaPublicacion - hoy) / (1000 * 60 * 60 * 24));
    return diferenciaDias >= 0 && diferenciaDias <= 4;
  };

  if (isLoading) {
    return (
      <Box sx={{ width: 350, my: 4 }}>
        <Skeleton variant="rectangular" width="100%" height={200} />
        <Box sx={{ pt: 0.5 }}>
          <Skeleton height={60} />
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      </Box>
    );
  }

  if (variant === "solo") {
    return (
      <div className="mt-4 contenedor-card" style={{ display: "flex", justifyContent: "center" }}>
        <Card
          className="card-publicacion-indiv"
          sx={{
            boxShadow: 'none',
            borderRadius: "10px",
            padding: "5px"
          }}
          onClick={() => {
            const eventoData = {
              id: publicacion.idevento,
              evento: publicacion.evento.evento
            };
            history.push(generateEventoUrl(eventoData));
          }}
        >
          {publicacion.attachs && publicacion.attachs.length > 0 && (
            <div style={{ position: 'relative', height: "100%", maxHeight: "300px" }}>
              <CardMedia
                sx={{
                  width: "370px",
                  cursor: "pointer",
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  }
                }}
                className="media-publicacion-indiv"
                component={publicacion.attachs[activeIndex].url.includes("video") ? "video" : "img"}
                src={publicacion.attachs[activeIndex].url}
                alt={publicacion.titulo}
                controls={publicacion.attachs[activeIndex].url.includes("video")}
                onClick={() => {
                  const eventoData = {
                    id: publicacion.idevento,
                    evento: publicacion.evento.evento
                  };
                  history.push(generateEventoUrl(eventoData));
                }}
              />
              {maxSteps > 1 && (
                <>
                  <IconButton
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: "#5656FF"
                    }}
                    onClick={(e) => {
                      handleIconClick(e);
                      previous();
                    }}
                  >
                    <KeyboardArrowLeft />
                  </IconButton>
                  <IconButton
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: "#5656FF"
                    }}
                    onClick={(e) => {
                      handleIconClick(e);
                      next();
                    }}
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                  <MobileStepper
                    steps={maxSteps}
                    position="static"
                    activeStep={activeIndex}
                    style={{
                      background: 'transparent',
                      position: 'absolute',
                      bottom: 0,
                      width: '100%',
                    }}
                    nextButton={<div />}
                    backButton={<div />}
                  />
                </>
              )}
            </div>
          )}

          <CardContent className="contenido-publicacion-indiv">
            <p className="title-publicacion-indiv">
              {publicacion.titulo}
            </p>

            <div className="d-flex justify-content-between align-items-center mb-1">
              <div className="fechaHora-publicacion">
                <div className="fecha-publicacion d-flex align-items-center">
                  <CalendarMonthOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                  <small>
                    {i18n.language === 'es'
                      ? moment(publicacion.evento?.fechas[0].fecha).clone().local().format("D [de] MMM")
                      : moment(publicacion.evento?.fechas[0].fecha).clone().local().format("MMM[,] D")}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  <AccessAlarmsOutlined fontSize="small" sx={{ marginRight: "5px" }} />
                  <small>{moment(publicacion.evento?.fechas[0].hora_inicio).clone().local().format('LT')}</small>
                </div>
              </div>
            </div>

            <p className="mb-0">
              Lugar: {publicacion.evento?.direccion}
            </p>

            <p className="descripcion">
              {publicacion.descripcion.length > 85
                ? `${publicacion.descripcion.substring(0, 85)}...`
                : publicacion.descripcion
              }
            </p>

            <div>
              <div className="d-flex align-items-center justify-content-end gap-3" onClick={handleIconClick}>
                <LikeButton
                  isLoading={isLoading}
                  usuario={usuario}
                  publicacionId={publicacion.id}
                  style={{ color: "#5656FF" }}
                />
                <ShareButton
                  idEvento={publicacion.idevento}
                  style={{ color: "#5656FF" }}
                />
                <Button
                  sx={{
                    fontSize: '16px',
                    padding: '8px 15px',
                    backgroundColor: '#5656FF',
                    color: 'white',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#3939AA',
                    },
                  }}
                  onClick={() => {
                    const eventoData = {
                      id: publicacion.idevento,
                      evento: publicacion.evento.evento
                    };
                    history.push(generateEventoUrl(eventoData));
                  }}
                >
                  Ver más
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // normal (cards pequeñas)
  return (
    <div className="mt-4">
      <Card
        className="card-publicacion"
        sx={{ boxShadow: 'none', cursor: "pointer" }}
        onClick={() => {
          const eventoData = {
            id: publicacion.idevento,
            evento: publicacion.evento.evento
          };
          history.push(generateEventoUrl(eventoData));
        }}
      >
        {publicacion.attachs && publicacion.attachs.length > 0 && (
          <div style={{ position: 'relative' }}>
            <CardMedia
              className="media-publicacion"
              component={publicacion.attachs[activeIndex].url.includes("video") ? "video" : "img"}
              src={publicacion.attachs[activeIndex].url}
              alt={publicacion.titulo}
              controls={publicacion.attachs[activeIndex].url.includes("video")}
            />
            {maxSteps > 1 && (
              <>
                <IconButton
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: "#5656FF"
                  }}
                  onClick={(e) => {
                    handleIconClick(e);
                    previous();
                  }}
                >
                  <KeyboardArrowLeft />
                </IconButton>
                <IconButton
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: "#5656FF"
                  }}
                  onClick={(e) => {
                    handleIconClick(e);
                    next();
                  }}
                >
                  <KeyboardArrowRight />
                </IconButton>
                <MobileStepper
                  steps={maxSteps}
                  position="static"
                  activeStep={activeIndex}
                  style={{
                    background: 'transparent',
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                  }}
                  nextButton={<div />}
                  backButton={<div />}
                />
              </>
            )}
          </div>
        )}

        <CardContent className="contenido-publicacion">
          <div>
            <p className="title-publicacion">
              {publicacion.titulo}
            </p>

            <div className="fechaHora-publicacion">
              <div className="fecha-publicacion d-flex align-items-center">
                <CalendarMonthOutlined
                  fontSize="small"
                  sx={{ marginRight: "5px" }}
                />
                <small>
                  {i18n.language === 'es'
                    ? moment(publicacion.evento?.fechas[0].fecha).clone().local().format("D [de] MMM")
                    : moment(publicacion.evento?.fechas[0].fecha).clone().local().format("MMM[,] D")}
                </small>
              </div>
              <div className="d-flex align-items-center">
                <AccessAlarmsOutlined
                  fontSize="small"
                  sx={{ marginRight: "5px" }}
                />
                <small>
                  {moment(publicacion.evento?.fechas[0].hora_inicio).clone().local().format('LT')}
                </small>
              </div>
            </div>

            <p className="descripcion">
              {publicacion.descripcion.length > 70
                ? `${publicacion.descripcion.substring(0, 70)}...`
                : publicacion.descripcion
              }
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CardPublicacion;